<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="`production-order-${order?.order_number || 'unknown'}`"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="orderPdf"
    >
      <section slot="pdf-content">
        <section class="pdf-item">
          <production-order-pdf-header :order-number="order.order_number" />

          <div class="w-full px-6 pb-6 text-blue-800 bg-gray-200">
            <p class="font-bold text-2xl" style="word-spacing: 0.5em;">
              {{ $t("production_order_detail.pdf.details") }}
            </p>
          </div>

          <div class="flex flex-col gap-4 mt-4">
            <div class="w-full px-6 text-blue-800 bg-gray-200">
              <production-order-detail
                v-if="order"
                :order="order"
                :is-rtw-tailoring="isRtwTailoring"
              />
            </div>
          </div>
        </section>

        <div class="html2pdf__page-break" />

        <section class="pdf-item">
          <production-order-pdf-header :order-number="order.order_number" />

          <div class="w-full px-6 pb-6 text-blue-800 bg-gray-200">
            <p class="font-bold text-2xl" style="word-spacing: 0.5em;">
              {{ $t("production_order_detail.pdf.measurements") }}
            </p>
          </div>

          <div class="w-full px-6">
            <production-order-body-table
              :adjustments="adjustments"
              :adjustments-loading="false"
              :adjustments-error="''"
              :is-pdf="true"
            />
          </div>
        </section>

        <div class="html2pdf__page-break" />

        <section class="pdf-item">
          <production-order-pdf-header :order-number="order.order_number" />

          <div class="w-full px-6 pb-6 text-blue-800 bg-gray-200">
            <p class="font-bold text-2xl">
              {{ $t("production_order_detail.pdf.measurements") }}
            </p>
          </div>

          <div class="w-full px-6">
            <production-order-garment-table
              :adjustments="adjustments"
              :fit-adjustments="fitAdjustments"
              :adjustments-loading="false"
              :adjustments-error="''"
              :is-rtw-tailoring="isRtwTailoring"
              :is-pdf="true"
            />
          </div>
        </section>

        <div class="html2pdf__page-break" />

        <section class="pdf-item">
          <production-order-pdf-header :order-number="order.order_number" />

          <div
            class="flex flex-row justify-center items-center mx-auto text-blue-800 bg-gray-200"
            style="max-width: 100vw; padding: 0 0 2rem 0; position: relative;"
          >
            <p
              class="font-bold text-2xl"
              style="word-spacing: 0.5em; position: absolute; left: 1.5rem; top: 0.5rem;"
            >
              {{ $t("production_order_detail.pdf.images") }}
            </p>
            <div class="flex flex-col items-center mr-4">
              <p class="font-bold text-xl p-2 text-center mt-2 mb-2">
                {{ $t("production_order_detail.back_view") }}
              </p>
              <bodyprint-view
                :image-source="imageBack"
                :is-active="true"
                side="back"
                :flipped="false"
                :picture-height="558"
                :picture-width="418.5"
                :back-guide="cropBack"
                :side-guide="cropSide"
                :show-active-line="false"
              />
            </div>
            <div class="flex flex-col items-center ml-5 bg-gray-200">
              <p class="font-bold text-xl p-2 text-center mt-2 mb-2">
                {{ $t("production_order_detail.side_view") }}
              </p>
              <bodyprint-view
                :image-source="imageSide"
                :is-active="true"
                side="side"
                :flipped="false"
                :picture-height="558"
                :picture-width="418.5"
                :back-guide="cropBack"
                :side-guide="cropSide"
                :show-active-line="false"
              />
            </div>
          </div>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import ProductionOrderBodyTable from "@/components/production-order/production-order-body-table.vue";
import ProductionOrderPdfHeader from "@/components/production-order/export/pdf/production-order-pdf-header.vue";
import BodyprintView from "@/components/bodyprint/bodyprint-view.vue";
import ProductionOrderGarmentTable from "@/components/production-order/production-order-garment-table.vue";
import ProductionOrderDetail from "@/components/production-order/production-order-detail.vue";

import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "ProductionOrderPdfComponent",
  components: {
    VueHtml2pdf,
    ProductionOrderDetail,
    ProductionOrderGarmentTable,
    BodyprintView,
    ProductionOrderPdfHeader,
    ProductionOrderBodyTable
  },
  props: {
    order: Object,
    isRtwTailoring: Boolean,
    adjustments: Array,
    fitAdjustments: Array,
    imageBack: String,
    cropBack: Object,
    imageSide: String,
    cropSide: Object
  },
  methods: {
    async generatePdf() {
      await this.$nextTick();
      return this.$refs.orderPdf.generatePdf().then(() => {
        this.$refs.orderPdf.downloadPdf();
      });
    }
  }
};
</script>
